import api from './api';

export const getDMs = () => api.get('/dms');
export const createOrFindDM = (data) => api.post('/dms', data);
export const getDMThread = (threadId) => api.get(`/dms/${threadId}`);
export const updateDMThread = (threadId, data) => api.patch(`/dms/${threadId}`, data);
export const addDMParticipant = (threadId, userId) => api.post(`/dms/${threadId}/participants`, { userId });
export const removeDMParticipant = (threadId, userId) => api.delete(`/dms/${threadId}/participants/${userId}`);
export const setDMModerator = (threadId, userId, isModerator) => api.patch(`/dms/${threadId}/moderators`, { userId, isModerator });
export const getDMMessages = (threadId, params) => api.get(`/dms/${threadId}/messages`, { params });
export const sendDMMessage = (threadId, data) => api.post(`/dms/${threadId}/messages`, data);
export const markDMRead = (threadId) => api.post(`/dms/${threadId}/read`);
export const deleteDMMessage = (messageId) => api.delete(`/dms/messages/${messageId}`);
